import { WebComponents } from "@/interfaces";
import { useAccountSettings, useSocialCoachSession } from "@/utils";
import { useMemo } from "react";

export interface UserContextData {
  isPlayer: boolean;
  isCoach: boolean;
  isAssistantCoach: boolean;
  hasWritePermission: boolean;
  playerId?: number;
  coachId?: number;
  userId?: number;
}

export const InitialUserContextData: UserContextData = {
  isPlayer: false,
  isCoach: false,
  isAssistantCoach: false,
  hasWritePermission: false,
  playerId: undefined,
  coachId: undefined,
  userId: undefined,
};

export const UserContext = (): UserContextData => {
  const { isPlayer, isCoach, isAssistantCoach, playerId, coachId, userId } = useSocialCoachSession();
  const { hasWritePermission: checkPermission } = useAccountSettings();
  const hasWritePermission = useMemo(() => {
    return checkPermission(WebComponents.PLAYER_CARDS);
  }, [checkPermission]);

  return {
    isPlayer,
    isCoach,
    isAssistantCoach,
    hasWritePermission,
    playerId,
    coachId,
    userId,
  };
};
